import { render, staticRenderFns } from "./ChatBoxTextButton.vue?vue&type=template&id=e47af272&scoped=true&"
import script from "./ChatBoxTextButton.vue?vue&type=script&lang=js&"
export * from "./ChatBoxTextButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxTextButton.vue?vue&type=style&index=0&id=e47af272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47af272",
  null
  
)

export default component.exports